var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_206_1",
    "data-name": "Component 206 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7569",
    "data-name": "Rectangle 7569",
    width: 32,
    height: 32,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15220",
    "data-name": "Group 15220",
    transform: "translate(-216.607 -2928.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15219",
    "data-name": "Group 15219",
    transform: "translate(222.173 2934.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15216",
    "data-name": "Group 15216",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15213",
    "data-name": "Group 15213",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15217",
    "data-name": "Group 15217"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6532",
    "data-name": "Rectangle 6532",
    width: 7.554,
    height: 7.554,
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6533",
    "data-name": "Rectangle 6533",
    width: 7.554,
    height: 7.554,
    transform: "translate(12.713 12.713)",
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_824",
    "data-name": "Line 824",
    x2: 5.159,
    y2: 5.159,
    transform: "translate(7.554 7.555)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15215",
    "data-name": "Group 15215",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15218",
    "data-name": "Group 15218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14645",
    "data-name": "Path 14645",
    d: "M30.255,8.7V.5h-8.2",
    transform: "translate(-9.82 -0.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14646",
    "data-name": "Path 14646",
    d: "M.5,21.5v8.512H9.012",
    transform: "translate(-0.5 -9.581)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.fb23bd171a1bc38afc370dc9b052dd7a.svg";
export { ForwardRef as ReactComponent };